import constantes from '../helpers/constanteHelper'

import Form from 'react-bootstrap/Form'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

import iconeHint from '../images/hint.svg'


function FiltrosPontosDeVendaEmpresaA2A2({ estados = [], cidades = [], setFiltroEstado, setFiltroCidade }) {
    return (
        <Form style={{ gap: '20px' }} className=' mb-5 d-flex flex-wrap justify-content-center align-items-center' noValidate id='form-cadastro'>
            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <div className='mb-2 d-flex align-items-center justify-content-start'>
                    <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO, margin: 0 }} className='fw-bold'>Filtro por estado</Form.Label>
                    <OverlayTrigger placement="top"
                        overlay={<Tooltip>
                            {'O filtro mostra apenas estados onde a empresa atua.'}
                        </Tooltip>}>
                        <img className='ms-2' height={18} src={iconeHint} alt="dica" />
                    </OverlayTrigger>
                </div>
                <Form.Select
                    onChange={(e) => {
                        setFiltroEstado(e.target.value)
                    }}
                >
                    <option value={''}></option>
                    {estados.map((estado) => <option key={estado} value={estado}>{estado}</option>)}
                </Form.Select>
            </Form.Group>
            <Form.Group style={{ width: '300px' }} controlId='nome'>
                <div className='mb-2 d-flex align-items-center justify-content-start'>
                    <Form.Label style={{ color: constantes.CORES.BRANCO_PADRAO, margin: 0 }} className='fw-bold'>Filtro por cidade</Form.Label>
                    <OverlayTrigger placement="top"
                        overlay={<Tooltip>
                            {'O filtro mostra apenas cidades onde a empresa atua.'}
                        </Tooltip>}>
                        <img className='ms-2' height={18} src={iconeHint} alt="dica" />
                    </OverlayTrigger>
                </div>
                <Form.Select
                    onChange={(e) => {
                        setFiltroCidade(e.target.value)
                    }}
                >
                    <option value={''}></option>
                    {cidades.map((cidade) => <option key={cidade} value={cidade}>{cidade}</option>)}
                </Form.Select>
            </Form.Group>
        </Form>
    )
}

export default FiltrosPontosDeVendaEmpresaA2A2